import {
  RoleFormInterface,
  ValidationSet,
  roleFormApiInterface
} from '../../../../types/interface';
import { commonValidations } from '../validations';

export const RoleFormValidationSet: ValidationSet<
  roleFormApiInterface & RoleFormInterface
> = {
  modules: commonValidations.moduleArray,
  is_archived: [],
  role_name: commonValidations.roleNameEn,
  role_name_de: commonValidations.roleNameDe
};
